<template>
    <div v-if="isPhone" style="padding: 5px 2px;">
        <span style="font-size: 10px;color: rgba(0,0,0,0.45)" class="paper-help-color1">小贴士：微信点右上角 “⋯”→选 “星标”，就能把网站存起来随时用</span>
        <span style="float: right">
            <HomeIcon/>
        </span>
    </div>
    <div style="background: #fff;">
        <div style="max-width: 1000px; padding: 2%; margin: 15px auto">
            <a-form ref="formRef" :model="formState" layout="vertical">
                <PaperSlogan/>
                <a-form-item style="margin-top: 10px">
                    <a-upload-dragger
                            v-model:file-list="fileList"
                            name="file"
                            :action="UploadPdfAction"
                            @change="handleChangeUpload"
                            @remove="handleRemove"
                            :headers="headers"
                            :before-upload="beforeUpload"
                            accept=".pdf"
                    >
                        <div class="upload">
                            <p class="ant-upload-drag-icon">
                                <file-pdf-outlined size="100"/>
                            </p>
                            <p class="ant-upload-text">
                                智能总结并生成文献的语音和视频讲解
                            </p>
                            <p class="ant-upload-hint">
                                点击或拖拽PDF文件到此处上传
                            </p>
                        </div>
                    </a-upload-dragger>
                    <template #help>
                        <p>注：每次解读消耗 20 积分，上传<b>新文献</b>可获取 30 积分。[查看<a href="/account" target="_blank">我的积分</a>]</p>
                    </template>
                </a-form-item>
                <p style="text-align: right">
                    <a-button @click="handleSubmit" type="primary" size="large" :disabled="disabled">
                        开始解析文献 <LoadingOutlined v-if="loading"/><ClockCircleOutlined v-else/>
                    </a-button>
                </p>
            </a-form>
            <a-modal v-model:open="open" title="解析" @ok="()=>onOk">
                <div style="margin-bottom: 20px; padding-right: 5px;">
                    <div style="padding: 1%; margin: 0 auto">
                        <a-space>
                            <span style="padding: 10px; border-radius: 5px; background: #c4302e">
                                <FilePdfOutlined style="color: #fff;font-size: 16px"/>
                            </span>
                            <div style="padding: 10px; border: 1px solid #ddd; border-radius: 5px; background: #FAFCF9;" class="percent-card">
                                <div v-if="!open1">
                                    <a-typography-text :ellipsis="true" :content="paper.title_cn" sytle="max-width: 400px"/>
                                    <a-space>
                                        <LoadingComponent/>
                                    </a-space>
                                </div>
                                <a-progress :percent="percent" :show-info="false" />
                                <p v-if="open1">
                                    已存在解读内容，确认后直接跳转查看（不消耗积分）。
                                </p>
                                <div v-else>
                                    <a-space>
                                        解析中<LoadingComponent/>
                                    </a-space>
                                    <span style="float: right">{{parse_text}}</span>
                                </div>
                            </div>


                        </a-space>
                        <p>
                            <small>小贴士：解析需要大约15-30s，稍等片刻，马上就好。</small>
                        </p>
                    </div>
                </div>
                <template #footer>
                    <div v-if="open1" style="text-align: right">
                        <a-space>
                            <a-button @click="redo">
                                重新解读（积分-10）
                            </a-button>
                            <a-button type="primary" @click="jumpToDetail">
                                跳转查看
                            </a-button>
                        </a-space>
                    </div>
                </template>
            </a-modal>
        </div>
    </div>
</template>
<script>
    import {
        FilePdfOutlined, ClockCircleOutlined, LoadingOutlined,
    } from '@ant-design/icons-vue';
    import { defineComponent } from 'vue';
    import {
        post_biogpt_upload_pdf,
        jumpToDetail
    } from "../utils/bioinfo.api";
    import {jy_tip} from "../utils/vue.tool";
    import {isDEV, UploadPdfAction, authHeaders} from "../utils/request";
    import {
        get_biogpt_upload_status,
        post_biogpt_paper_upload_info
    } from "../utils/bioinfo.api";
    import LoadingComponent from '../components/LoadingComponent'
    import PaperSlogan from '../components/PaperSlogan'
    import HomeIcon from '../components/HomeIcon'
    import {isLogin, isMobile, isPhone, jumpToLogin} from "../utils/llm.tools";
    const fileTipPages = '文档页数超出限制（>50页），暂不支持。';
    const fileSizeLimit = 50;
    const fileTipSize = '文件大小超出限制（>' + fileSizeLimit + 'M），暂不支持。';
    export default defineComponent({
        name: "LiteratureUpload",
        components: {
            FilePdfOutlined,
            ClockCircleOutlined,
            LoadingComponent,
            LoadingOutlined,
            HomeIcon,
            PaperSlogan
        },
        data() {
            return {
                isPhone: isMobile(),
                open: false,
                open1: false,
                UploadPdfAction,
                loading: false,
                disabled: !isDEV,
                formState: {if_video: 1, if_audio: 1},
                headers: authHeaders({}),
                data: [],
                pushItems: [],
                fileList: [ ],
                link: '',
                method: '',
                modalTitle: '',
                upload_no: 0,
                status: 0,
                qrcode: '',
                title_cn: '',
                paper: {},
                parse_info: {},
                parse_text: '正在逐页分析',
                percent: 0,
                upload: 0,
                paper_no: 0,
            };
        },
        created(){
        },
        methods: {
            beforeUpload () {
                if(!isLogin())jumpToLogin('请先登录');
            },
            handleRemove(){
                this.loading = false;
                this.fileList = [];
                this.disabled = false;
            },
            handleChangeUpload(info){
                console.log('upload info', info);
                let {file} = info;
                this.fileList = [file];
                let {response, status, size} = file || {};
                console.log('response', file?.response);
                // this.items[1].dataSource[index][4] = 'xxx';

                if (status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if(size > fileSizeLimit * 1024 * 1024) this.setFileError(fileTipSize);
                else if (status === 'done') {
                    console.log('done');

                    let { data, status} = response || {'message': 'No response.'};
                    if(data && data.file_path){
                        this.disabled = false;
                        this.formState.pdf_path = data.file_path;
                    }
                    else if(status === 20401 || status === 20403) {
                        if(!isPhone) this.setFileError('检测到登录信息异常，请重新登录。');
                        else jumpToLogin();
                    }
                    else this.setFileError(status + ':' + response?.message);
                } else if (status === 'error') {
                    this.setFileError('请检查或稍后再试');

                }
            },
            handleSubmit(){
                this.postUpload();
            },
            postUpload(force_extract=0){
                let obj = this;
                let {formState} = obj;

                this.loading = true;

                if(isDEV){
                    // this.open1 = true;
                    // this.percent = 100;
                    this.open = true;
                    setInterval(()=>{
                        if(this.percent < 100) this.percent += 2;
                    }, 1000);
                } else post_biogpt_upload_pdf({...formState, force_extract}, (res)=>{
                    let {data, message, status} = res;
                    this.loading = false;
                    if(status === 1201309) {
                        this.open = false;
                        this.setFileError(fileTipPages)
                    }
                    else if(status === 1201310) {
                        this.open = false;
                        this.setFileError(fileTipSize)
                    }
                    else if(status === 1201319) {
                        this.open = false;
                        this.setFileError('可能您上传的是图片扫描件，请上传文本可识别的文献PDF。', '内容提取失败，')
                    }
                    else if(data){
                        this.open = true;
                        let {upload_no, paper_no} = data;
                        this.upload_no = upload_no;
                        this.paper_no = paper_no;
                        if(status === 1201308){
                            this.percent = 100;
                            this.open1 = true;
                        }
                        else {
                            this.getStatus(upload_no);
                        }
                    } else jy_tip('提交失败：' + message);
                })
            },
            getStatus(upload_no){
                let {status, percent} = this;
                if(status < 2) {
                    get_biogpt_upload_status({upload_no}, (res)=>{
                        let {data, message} = res;
                        console.log('get_biogpt_upload_status', res);
                        if(data){
                            let {status: newStatus, paper_no} = data;
                            this.paper_no = paper_no;
                            if(newStatus < 2) {
                                setTimeout(()=>{
                                    if(percent < 60) this.percent += 1.5;
                                    else if(percent < 100) this.percent += 0.5;
                                    this.overviewDetail(newStatus, paper_no, ()=>{
                                        this.getStatus(upload_no);
                                    });
                                }, 1000)
                            }else this.overviewDetail(newStatus, paper_no);
                        } else jy_tip(message);
                    })
                }
                else{
                    console.log('status', status)
                }
            },

            overviewDetail(newStatus, paper_no, func){
                let {upload_no} = this;
                console.log('overviewDetail', 'paper_no', paper_no);
                if(upload_no && paper_no) this.getDetail(newStatus, paper_no, func);
                else func();
            },
            getDetail(newStatus, paper_no, func){
                let {upload_no, parse_text, percent} = this;
                if(newStatus >= 2) this.jumpToDetail();
                else {
                    console.log('newStatus', newStatus);
                    post_biogpt_paper_upload_info({paper_no, upload_no}, (res)=>{
                        this.loading = false;
                        let {data} = res;
                        if(data){
                            let {parse_info, title_cn} = data;
                            this.parse_info = parse_info || {};
                            let {parse_step, page_count, page_num} = this.parse_info;
                            // 0已创建 1解析中，请稍后 2提取作者 3获取摘要 4逐页分析 解析1/18页  5生成总结
                            // 1： 0.2
                            // 2： 0.3
                            // 3:   0.5
                            // 4： 0.6
                            // 5： 0.9
                            if(parse_step === 0) parse_text = '已创建';
                            else if(parse_step === 1) {
                                parse_text = '解析中，请稍后';
                                percent = 20;
                            }
                            else if(parse_step === 2) {
                                parse_text = '提取作者';
                                percent = 30;
                            }
                            else if(parse_step === 3) {
                                parse_text = '获取摘要';
                                percent = 50;
                            }
                            else if(parse_step === 4) {
                                parse_text = '逐页分析, 解析' + page_num + '/' + page_count;
                                percent = 60;
                            }
                            else if(parse_step === 5) {
                                parse_text = '生成总结';
                                percent = 90;
                            }

                            this.parse_text = parse_text;
                            console.log('parse_text', parse_text);
                            this.percent = percent;
                            this.title_cn = title_cn;
                            this.paper = {...data};
                            if(func) func();
                        }
                    })
                }
            },
            redo(){
                this.open1 = false;
                this.percent = 0;
                this.postUpload(1);
            },
            jumpToDetail(){
                let {upload_no, paper_no} = this;
                jumpToDetail(upload_no, paper_no);
            },
            setFileError(msg, prefix='上传失败！'){
                this.disabled = true;
                this.fileList[0].name = prefix + msg;
                this.fileList[0].status = 'error';
            }
        }
    });
</script>

<style scoped>
    .upload{
        padding: 100px;
    }
    .percent-card {
        width: 420px;
    }
    /* 手机端 */
    @media (max-width: 480px) {
        .upload{
            padding: 50px;
        }
        .percent-card {
            width: 260px;
        }
    }
</style>
